import { Handle, Position } from "@xyflow/react";
import type { SocketKind } from "~/lib/types";

/** One color per socket kind, so compatible ports are recognizable at a glance. */
const SOCKET_COLORS: Record<SocketKind, string> = {
  number: "!bg-teal-400",
  vector: "!bg-violet-400",
  style: "!bg-amber-400",
  transform: "!bg-sky-400",
  color: "!bg-rose-400",
};

interface SocketHandleProps {
  id: string;
  kind: SocketKind;
  type: "source" | "target";
}

export function SocketHandle({ id, kind, type }: SocketHandleProps) {
  return (
    <Handle
      id={id}
      type={type}
      position={type === "source" ? Position.Right : Position.Left}
      title={kind}
      // `!` overrides the handle styling that ships with @xyflow/react.
      className={`size-3! rounded-sm! border! border-neutral-900! ${SOCKET_COLORS[kind]} ${
        type === "source" ? "-right-3!" : "-left-3!"
      }`}
    />
  );
}
